import { gql } from '@apollo/client';
import CommonFragments from 'features/common/fragments';

export const CONVENTION_GENERAL_DATA_UPDATED = gql`
  subscription insuranceConventionGeneralDataUpdated {
    insuranceConventionGeneralDataUpdated {
      convention {
        productId
        productCode
        productName
        isActive
        currencyId
        currencyCode
        startDate
        endDate
        productPeriod
        defaultProductPeriod
        trackingTypeId
        insuranceTypeId
        insuredAmountTypeId
        insuranceAmountId
        conventionTypeId
        insuranceValueFormula
        amountTypeFormula
        validateInsuredAmount
        roundInsuredAmount
        roundInsuranceAmount
        roundInsuranceRate
        baseInsurancePercentFormula
        genericFilterTemplateId
        minInsuranceAmount
        calculationInfoChanged
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;

export const INSURANCE_CONVENTION_CONDITIONS_UPDATED = gql`
  subscription insuranceConventionConditionsUpdated($productId: Int!) {
    insuranceConventionConditionsUpdated(productId: $productId) {
      convention {
        productId
        productCode
        productName
        isActive
        currencyId
        startDate
        endDate
        productPeriod
        defaultProductPeriod
        trackingTypeId
        insuranceTypeId
        insuredAmountTypeId
        insuranceAmountId
        conventionTypeId
        insuranceValueFormula
        validateInsuredAmount
        roundInsuredAmount
        roundInsuranceAmount
        roundInsuranceRate
        genericFilterTemplateId
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;

export const INSURANCE_CONVENTION_RISK_SAVED = gql`
  subscription insuranceConventionRiskSaved {
    insuranceConventionRiskSaved {
      isNew
      productId
      initialInsuranceTypeId
      initialRiskTypeId
      risk {
        productId
        insuranceTypeId
        insuranceTypeName
        riskTypeId
        riskTypeName
        riskPercent
        riskAmount
        defaultYN
        mandatoryYN
        readOnlyYN
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;

export const INSURANCE_CONVENTION_RISK_DELETED = gql`
  subscription insuranceConventionRiskDeleted {
    insuranceConventionRiskDeleted {
      productId
      insuranceTypeId
      riskTypeId
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;

export const INSURANCE_CONVENTION_COMMISSION_UPDATED = gql`
  subscription insuranceConventionCommissionUpdated {
    insuranceConventionCommissionUpdated {
      isNew
      productId
      initialInsuranceTypeId
      commission {
        productId
        insuranceTypeId
        insuranceTypeName
        commission
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;

export const INSURANCE_CONVENTION_COMMISSION_DELETED = gql`
  subscription insuranceConventionCommissionDeleted {
    insuranceConventionCommissionDeleted {
      productId
      insuranceTypeId
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;

export const INSURANCE_USAGE_GRID_SAVED = gql`
  subscription insuranceUsageGridSaved {
    insuranceUsageGridSaved {
      isNew
      usageGrid {
        id
        productId
        categoryId
        age
        usagePercent
        insurancePercent
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;

export const INSURANCE_USAGE_GRID_DELETED = gql`
  subscription insuranceUsageGridDeleted {
    insuranceUsageGridDeleted {
      usageGridId
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;

export const INSURANCE_CONVENTION_INSURER_UPDATED = gql`
  subscription insuranceConventionInsurerUpdated {
    insuranceConventionInsurerUpdated {
      insuranceConventionInsurer {
        productId
        insurerId
        insurerName
        isDefault
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;

export const CONVENTION_INSURER_DELETED = gql`
  subscription insuranceConventionInsurerDeleted {
    insuranceConventionInsurerDeleted {
      productId
      insurerId
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;

export const INSURANCE_CONVENTION_ITEM_TYPE_UPDATED = gql`
  subscription insuranceConventionItemTypeUpdated {
    insuranceConventionItemTypeUpdated {
      isNew
      productId
      initialItemTypeId
      itemType {
        productId
        itemTypeId
        itemTypeName
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;

export const INSURANCE_CONVENTION_ITEM_TYPE_DELETED = gql`
  subscription insuranceConventionItemTypeDeleted {
    insuranceConventionItemTypeDeleted {
      productId
      itemTypeId
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;

export const INSURANCE_CONVENTION_DEDUCTIBLE_COST_SAVED = gql`
  subscription insuranceConventionDeductibleCostSaved {
    insuranceConventionDeductibleCostSaved {
      isNew
      deductibleCostId
      deductibleCost {
        deductibleCostId
        productId
        damageTypeId
        damageTypeName
        deductibleCostPercent
        deductibleCostAmount
        currencyId
        currencyCode
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;

export const INSURANCE_CONVENTION_DEDUCTIBLE_COST_DELETED = gql`
  subscription insuranceConventionDeductibleCostDeleted {
    insuranceConventionDeductibleCostDeleted {
      deductibleCostId
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;

export const INSURANCE_CONVENTION_ADDITIONAL_DATA_SAVED = gql`
  subscription insuranceConventionAdditionalDataSaved($productId: Int!) {
    insuranceConventionAdditionalDataSaved(productId: $productId) {
      insuranceConventionAdditionalData {
        insuranceConventionAdditionalDataId
        additionalDataTypeId
        additionalDataTypeName
        detailId
        detailName
        insuranceConventionId
        relativePercent
        percentFormula
        isDefault
        genericFilterTemplateId
        amount
        amountFormula
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;

export const INSURANCE_CONVENTION_ADDITIONAL_DATA_DELETED = gql`
  subscription insuranceConventionAdditionalDataDeleted {
    insuranceConventionAdditionalDataDeleted {
      insuranceConventionAdditionalDataId
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;
